const mutations = {
  SAVE_DATA(state, data) {
    localStorage.setItem('home', JSON.stringify(data));
    state.home = data;
  },
  RE_KYC_STATUS(state, data) {
    state.reKycStatus = data;
    localStorage.setItem('reKycStatus', JSON.stringify(data));
  },
};
export default mutations;
